import * as actions from "../constants/cartConstants";

export const cartReducers = (
  state = { cartItems: [], shippingAddress: [], paymentMethod: "" },
  action
) => {
  switch (action.type) {
    case actions.CART_ADD_ITEM:
      const item = action.payload;

      // Cart uniqueness now by product AND size
      const existItem = state.cartItems.find(
        (x) => x.product === item.product && x.size === item.size
      );

      if (existItem) {
        return {
          ...state,
          cartItems: state.cartItems.map((x) =>
            x.product === existItem.product && x.size === existItem.size
              ? item
              : x
          ),
        };
      } else {
        return {
          ...state,
          cartItems: [...state.cartItems, item],
        };
      }

    case actions.CART_REMOVE_ITEM:
      return {
        ...state,
        // Remove by both product and size
        cartItems: state.cartItems.filter(
          (x) =>
            !(
              x.product === action.payload.id &&
              x.size === action.payload.size
            )
        ),
      };

    case actions.CART_SAVE_SHIPPING_ADDRESS:
      return {
        ...state,
        shippingAddress: action.payload,
      };

    case actions.CART_SAVE_PAYMENT_METHOD:
      return {
        ...state,
        paymentMethod: action.payload,
      };

    case actions.CART_CLEAR_ITEMS:
      return {
        ...state,
        cartItems: [],
      };

    default:
      return state;
  }
};

